import { Text } from '@billy/design-system'
import { ReactElement } from 'react'

import * as Styled from './styles'
import { BankLogoSize } from './types/bankLogoSize'

interface BankLogoProps {
  name: string
  logoUrl?: string
  size?: BankLogoSize
}

export const BankLogo = ({ name, logoUrl, size = 'medium' }: BankLogoProps): ReactElement => {
  const firstLetter = name.charAt(0).toUpperCase()

  if (!logoUrl) {
    return (
      <Styled.BlankImageContainer size={size}>
        <Text variant={size === 'small' ? 'bodySM' : 'h4'}>{firstLetter}</Text>
      </Styled.BlankImageContainer>
    )
  }

  return (
    <Styled.ImageContainer size={size}>
      <img src={logoUrl} alt={name} />
    </Styled.ImageContainer>
  )
}
